module.exports = __webpack_public_path__ + "static/media/swimmy-story-pool-mobile.dd991ddd.png";